import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistrationFormComponent } from 'src/app/components/registration-form/registration-form.component';
import { CreateUser, createuserdefaultvalues } from 'src/app/components/users/createuser';
import { LlttfInvitationService } from 'src/app/services/llttf-invitation.service';
import { ToastService } from 'src/app/services/toast-service.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-register-llttf-participant',
    templateUrl: './register-llttf-participant.component.html',
    styleUrls: ['./register-llttf-participant.component.scss'],
    standalone: false
})
export class RegisterLlttfParticipantComponent {
  @ViewChild(RegistrationFormComponent) registrationForm!:RegistrationFormComponent; 
  createuserobj:CreateUser=createuserdefaultvalues();
  verificationguid:string=''
  isSubmitted:boolean=false
  constructor(private _userservice:UserService,private route:ActivatedRoute,public router:Router,private _llttfinviteservice:LlttfInvitationService,
    private _toastservice:ToastService) { }

  ngOnInit(){
    this.route.params.subscribe(params => {
      this.verificationguid = params['guid'];
      this._llttfinviteservice.getEmailFromVerificationGuid(this.verificationguid).subscribe({
        next: (response) => {
          this.createuserobj.userName=response.email;
        }
      })
    })
  }

  onSubmit(){
    this.isSubmitted=true;
    if(!this.registrationForm.validateRequiredFields())
    {
      this._toastservice.showErrorMessage("Please correct all the errors on the form")
      return;
    }
    
    this._userservice.registerLLTTFCoachedParticipant(this.createuserobj,this.verificationguid).subscribe({
      next: (response) => {
        this.router.navigateByUrl("/account-created/llttf");
      }
    })
  }
}
